import { formatTime, I18nt } from 'utils';
import styles from './AgendarCita.module.less';
import ModalWithImage from 'components/ModalwithImage';
import { Button, Checkbox, Form } from 'antd';
import { useState } from 'react';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { InputText } from 'components/Inputs';
import validations from 'utils/validations/ContactForm';
import { LangText } from 'utils/interfaces';
import { useAgendarCita } from '../AgendarCitaContext';
import InfoModal from 'components/InfoModal';

interface ModalContent {
	[key: string]: { title: LangText; body?: LangText };
}

const modalContent: ModalContent = {
	'-1': {
		title: 'numero_de_afiliado_no_encontrado',
		body: 'el_numero_que_ingresaste',
	},
	'-2': {
		title: 'numero_afiliado_inactivo',
		body: 'para_poder_consultar_la_disponibilidad',
	},
	'-3': {
		title: 'numero_de_dui_no_encontrado',
		body: 'el_numero_que_ingresaste',
	},
	'-4': {
		title: 'el_dui_no_coincide',
		body: 'el_numero_de_dui_que_ingresaste',
	},
	'-5': {
		title: 'numero_de_afiliado_no_encontrado',
		body: 'el_numero_que_ingresaste',
	},
};

const citasResponseContent: ModalContent = {
	'-2': {
		title: 'numero_de_afiliado_no_encontrado',
		body: 'el_numero_que_ingresaste',
	},
	'-3': {
		title: 'numero_afiliado_inactivo',
		body: 'para_poder_agendar_su_cita',
	},
	'-4': {
		title: 'horario_no_disponible',
		body: 'lo_sentimos_este_horario',
	},
	'-5': {
		title: 'lo_sentimos',
		body: 'ocurrio_un_error',
	},
};

export function FormResponseModal() {
	const { statusMessage, dispatch } = useAgendarCita();

	if (!statusMessage) {
		return null;
	}
	const message = modalContent[statusMessage];
	if (!message) {
		return null;
	}
	return (
		<InfoModal
			onOk={() => dispatch({ type: 'reset' })}
			okText='de_acuerdo'
			body={message.body}
			title={message.title}
			visible={Boolean(statusMessage)}
		/>
	);
}

export function ConfirmacionCitaModal() {
	const [form] = Form.useForm();
	const [checked, setChecked] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const {
		patient,
		agendarCita,
    agendarCitaDoctor,
		selectedDate,
		selectedTime,
		selectedClinic,
		showConfirmarCita,
		setShowConfirmarCita,
    selectedCategory,
    selectedDoctor,
    isSpecialist,
    phone,
	} = useAgendarCita();

	const onChangeHandler = ({ target }: CheckboxChangeEvent) => {
		setChecked(target.checked);
	};

	const resetForm = () => {
		setChecked(false);
		form.resetFields();
		setIsLoading(false);
	};

	const onSubmit = () => {
		setIsLoading(true);
		if (checked) {
			form.submit();
			form
				.validateFields(['correo'])
				.then(({ correo }) => {
          if(isSpecialist) {
            agendarCitaDoctor(correo, resetForm, phone);
          } else {
            agendarCita(correo, resetForm);
          }
        })
				.catch(() => setIsLoading(false));
		} else {
      if(isSpecialist) {
        agendarCitaDoctor('', resetForm, phone);
      } else {
        agendarCita('', resetForm);
      }
		}
	};

	const onCancel = () => {
		resetForm();
		setShowConfirmarCita(false);
	};

	const emailForm = () => {
		if (checked) {
			return (
				<Form validateTrigger='onBlur' form={form} layout='vertical'>
					<InputText
						name='correo'
						inputMode='email'
						rules={validations.correo}
						label='ingresa_tu_correo_electronico'
						placeholder='placeholder_email'
					/>
				</Form>
			);
		}
		return null;
	};

  const displayPlaceInfo = () => {
    if(isSpecialist) {
      return (
        <>
          <li>
            <strong>{I18nt('medico')}:&nbsp;</strong>
            {selectedDoctor?.nombreMedico}
          </li>
          <li>
            <strong>{I18nt('especialidad')}:&nbsp;</strong>
            {selectedCategory?.nombreEspecialidad}
          </li>
          <li>
            <strong>{I18nt('lugar')}:&nbsp;</strong>
            {selectedDoctor?.nombreEstablecimiento}
          </li>
        </>
      );
    }
    return (
      <li>
        <strong>{I18nt('lugar')}:&nbsp;</strong>
        {selectedClinic?.establecimiento}
      </li>
    );
  };

	return (
		<ModalWithImage
			centered
			width={328}
			footer={null}
			closable={false}
			visible={showConfirmarCita}
		>
			<h4 className={styles.modalTitle}>
				{I18nt('confirmacion_de_cita_medica')}
			</h4>
			<div className={styles.confirmationModalList}>
				<ul>
					<li>
						<strong>{I18nt('paciente')}:&nbsp;</strong>
						{`${patient?.nombrePaciente} ${patient?.apellidoPaciente}`}
					</li>
          {displayPlaceInfo()}
					<li>
						<strong>{I18nt('fecha')}:&nbsp;</strong>
						{selectedDate}
					</li>
					<li>
						<strong>{I18nt('hora')}:&nbsp;</strong>
						{formatTime(selectedTime)}
					</li>
				</ul>
			</div>
			<div>
				<Checkbox checked={checked} onChange={onChangeHandler}>
					{I18nt('deseo_recibir_un_recordatorio')}
				</Checkbox>
				{emailForm()}
			</div>
			<div className={styles.footer}>
				<p>{I18nt('esta_seguro_que_desea_confirmar')}</p>
				<div>
					<Button onClick={onCancel}>{I18nt('no_regresar')}</Button>
					<Button loading={isLoading} onClick={onSubmit} type='primary'>
						{I18nt('si_confirmar')}
					</Button>
				</div>
			</div>
		</ModalWithImage>
	);
}

export function CreateCitaResponseModal() {
	const { crearCitaMessage, dispatch } = useAgendarCita();

	if (!crearCitaMessage) {
		return null;
	}
	const message = citasResponseContent[crearCitaMessage];
	if (!message) {
		return null;
	}
	return (
		<InfoModal
			okText='de_acuerdo'
			body={message.body}
			title={message.title}
			visible={Boolean(crearCitaMessage)}
			onOk={() => dispatch({ type: 'setCrearCitaMessage' })}
		/>
	);
}
